import { FORM_MEDIA_BUCKET } from "./formMediaBucket";

export interface CarouselImage {
    src: string;
    alt: string;
}

/**
 * The images of an image-carousel block, stored in blocks.content as JSON:
 * [{ "src": "leafepsc/picture-a.png", "alt": "Picture A: ..." }, ...].
 * A bare src is a path in the form-media bucket and becomes its public URL; a full URL or a
 * root path ("/forms/...") is used as it is. Entries without a src are dropped; a missing alt
 * becomes empty. Bad JSON gives no images.
 */
export function parseCarouselImages(
    content: string | null | undefined,
    supabaseUrl: string = import.meta.env.VITE_SUPABASE_URL ?? ""
): CarouselImage[] {
    if (!content?.trim()) return [];
    let raw: unknown;
    try {
        raw = JSON.parse(content);
    } catch {
        return [];
    }
    if (!Array.isArray(raw)) return [];
    return raw.flatMap((item) => {
        if (!item || typeof item !== "object") return [];
        const { src, alt } = item as { src?: unknown; alt?: unknown };
        if (typeof src !== "string" || !src.trim()) return [];
        return [{ src: formMediaUrl(src.trim(), supabaseUrl), alt: typeof alt === "string" ? alt : "" }];
    });
}

/** Public URL of a form-media path. URLs, root paths, data: and blob: sources pass through. */
export function formMediaUrl(src: string, supabaseUrl: string): string {
    if (/^([a-z][a-z0-9+.-]*:|\/)/i.test(src)) return src;
    const path = src.split("/").map(encodeURIComponent).join("/");
    return `${supabaseUrl.replace(/\/+$/, "")}/storage/v1/object/public/${FORM_MEDIA_BUCKET}/${path}`;
}
